import React, { useEffect, useState } from "react";
import Helmet from "react-helmet";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import PageTitle from "../../components/common/pageTitle";
import { Tiles, Content, ModalForms } from "../../components/codeactivation";
import { FormInputControl } from "../../components/common";
import Spinner from "../../shared/Spinner";
import { useSelector } from "react-redux";
//style
import style from "../../components/codeactivation/codeactive.module.scss";
import PaypalPayment from "../../components/Payments/PaypalPayment";
import CodeActiveService from "../../../service/codeActivation/CodeActive";
import UserStore from "../../../store/UserStore";
//data
import codedata from "./codedata.json";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import companyName from "../../../store/mobxStore/companyName";
import CodeActModal from "../../components/codeactivation/CodeActModal";

const mapStateToProps = (state) => ({ lang: state.Lang });

const CodeActivation = (props) => {
  const Currency = useSelector((state) => state.curr);
  const { t } = props;
  const [checkout, setCheckout] = useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [monthsList, setMonthsList] = React.useState([]);

  const handleClick = (e) => {
    setShowModal(true);
    e.stopPropagation();
  };

  const closeModal = () => {
    setShowModal(false);
  };

  const [EwalletAmount, setEwalletAmount] = useState({
    amount: "",
    FormError: {
      amount: "",
    },
    isvalid: false,
  });

  const [loader, setLoader] = useState({
    EarningsTable: {
      search: false,
      reset: false,
      excel: false,
      csv: false,
      print: false,
    },
    HistoryTable: {
      search: false,
      reset: false,
      excel: false,
      csv: false,
      print: false,
    },
  });

  const [locationKeys, setLocationKeys] = useState([]);
  const history = useHistory();
  const [selectedTab, setselectedTab] = useState("activationCodeHistory");
  const [reload, setReload] = useState(false);
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setEwalletAmount((prev) => ({
      ...prev,
      [name]: value,
      FormError: {
        ...prev.FormError,
        [name]: "",
      },
      isvalid: false,
    }));
  };

  const [state, setState] = useState({
    Modal: {
      fundTransfer: false,
      addWallet: false,
    },
    tilesData: [],
    activationHistory: false,
    downlineActivationHistory: false,
    balanceAmount: "",
    TransactionFee: "",
    repurchase_status: "yes",
    loading: true,
    DataTables: {
      key: UserStore.checkUserEarnings ? "earning" : "statement",
      statement: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
      },
      history: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
        startDate: moment().subtract(29, "days"),
        endDate: moment(),
        direction: "",
      },
      wallet: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
      },
      earnings: {
        totalRows: 0,
        data: [],
        pending: true,
        perPage: 10,
        inPage: 1,
        startDate: moment().subtract(29, "days"),
        endDate: moment(),
        direction: "",
        category: [],
      },
    },
  });
  const [clientSecret, setClientSecret] = useState("");

  const service = new CodeActiveService();

  useEffect(() => {
    history.listen((location) => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
        if (location.pathname === "/dashboard") {
          UserStore.checkUserEarnings = false;
        }
      }
      if (history.action === "POP") {
        if (locationKeys[1] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
        } else {
          setLocationKeys((keys) => [location.key, ...keys]);
          UserStore.checkUserEarnings = false;
        }
      }
    });

    //componentdidmount
    loadData();
    return () => {
      setReload(false);
    };
  }, [props, locationKeys, Currency.currentCurr, reload]);

  const checkAvailable = () => {
    let valid = true;

    if (!EwalletAmount.amount) {
      valid = false;
      setEwalletAmount((prev) => ({
        ...prev,
        FormError: {
          ...prev.FormError,
          amount: t("validation.required", { field: "amount" }),
        },
      }));
    }
    if (valid) {
      setCheckout(true);
    }
  };

  //load the data
  const loadData = () => {
    console.log(codedata, "codedata");
    setState((prevState) => ({
      ...prevState,
      tilesData: codedata.ewallet_tile,
      balanceAmount: codedata.balance,
      TransactionFee: codedata.transactionFee,
      repurchase_status: codedata.repurchase_status,
      purchase_wallet: codedata.purchase_wallet,
      loading: false,
    }));
    //ewallet tiles
    service.Ewallet().then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          activationHistory: res.data.activationHistory,
          downlineActivationHistory: res.data.downlineActivationHistory,
        }));
        setMonthsList(res.data.monthsList);
        setState((prevState) => ({
          ...prevState,
          tilesData: res.data.codeActivationTiles,
        }));
      } else {
        props.history.push("/logout");
      }
    });
    getHistoryTable();
    getUserEarningsTable();
  };

  //get history tabla data
  const getHistoryTable = (
    inPage = state.DataTables.history.inPage,
    perPage = state.DataTables.history.perPage,
    direction = "",
    startDate = moment().startOf("month").format("MMMM D, YYYY"),
    endDate = moment().format("MMMM D, YYYY"),
    order = "",
    keys = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service
      .history(start, perPage, direction, startDate, endDate, order, keys)
      .then((res) => {
        if (res.status) {
          setLoader({
            EarningsTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
            HistoryTable: {
              search: false,
              reset: false,
            },
          });
          setState((prevState) => ({
            ...prevState,
            DataTables: {
              ...prevState.DataTables,
              history: {
                ...prevState.DataTables.history,
                totalRows: res.data.count,
                data: res.data.table_data,
                pending: false,
              },
            },
          }));
        } else {
          props.history.push("/logout");
        }
      });
  };

  //change table data
  const changeHistoryTable = (
    inPage,
    perPage,
    start,
    end,
    dierection,
    colKey,
    key
  ) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        history: {
          ...prevState.DataTables.history,
          perPage: perPage,
          inPage: inPage,
          // pending     : true,
          startDate: start,
          endDate: end,
          direction: dierection,
        },
      },
    }));
    getHistoryTable(inPage, perPage, dierection, start, end, colKey, key);
  };

  //get the userearnings table
  const getUserEarningsTable = (
    inPage = state.DataTables.earnings.inPage,
    perPage = state.DataTables.earnings.perPage,
    direction = "",
    startDate = moment().startOf("month").format("MMMM D, YYYY"),
    endDate = moment().format("MMMM D, YYYY"),
    order = "",
    keys = ""
  ) => {
    let start = (inPage - 1) * perPage;
    service
      .downline(start, perPage, direction, startDate, endDate, order, keys)
      .then((res) => {
        if (res.status) {
          setLoader({
            EarningsTable: {
              search: false,
              reset: false,
              excel: false,
              csv: false,
              print: false,
            },
            HistoryTable: {
              search: false,
              reset: false,
            },
          });

          setState((prevState) => ({
            ...prevState,
            DataTables: {
              ...prevState.DataTables,
              earnings: {
                ...prevState.DataTables.earnings,
                totalRows: res.data.count,
                data: res.data.result,
                pending: false,
                category: res.data.category,
              },
            },
          }));
        } else {
          props.history.push("/logout");
        }
      });
  };

  //change table data
  const changeEarningsTable = (
    inPage,
    perPage,
    start,
    end,
    dierection,
    colKey,
    key
  ) => {
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        earnings: {
          ...prevState.DataTables.earnings,
          perPage: perPage,
          inPage: inPage,
          // pending     : true,
          startDate: start,
          endDate: end,
          direction: dierection,
        },
      },
    }));
    getUserEarningsTable(inPage, perPage, dierection, start, end, colKey, key);
  };

  //add purchase wallet modal open
  const fundTransferModal = () => {
    setState((prevState) => ({
      ...prevState,
      Modal: {
        ...prevState.Modal,
        fundTransfer: true,
      },
    }));
  };

  //modal close
  const handleClose = () => {
    setCheckout(false);
    setEwalletAmount((prevState) => ({
      ...prevState,
      amount: "",
    }));
    setState((prevState) => ({
      ...prevState,
      Modal: {
        ...prevState.Modal,
        fundTransfer: false,
        addWallet: false,
      },
    }));
  };

  const Translation = (data, tab) => {
    let newData;
    if (tab === "activationCodeHistory") {
      newData = data.map((item) => {
        console.log("itemsss", item);
        if (item) {
          return {
            ...item,
            date_used: item.date_used,
            product_cost: `${Currency.currentCurr}${(
              parseFloat(item.product_cost) * Currency.value
            ).toFixed(Currency.precision)}`,
          };
        } else return item;
      });
    } else {
      console.log(" in else condition ");
      newData = data.map((item) => {
        if (item) {
          return {
            //...item,
            // id:item.id+1,
            level: item.level,
            username: item.username,
            name: item.name,
            // activation_code: item.activation_code,
            // security_code: item.security_code,
            pv: item.pv,
          };
        } else return item;
      });
    }

    return newData;
  };

  const ExportToExcel = (apiData, fileName, type, tab) => {
    console.log("ExportToExcel", tab);
    let fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let fileExtension = ".xlsx";
    if (tab === "activationCodeHistory") {
      if (type === "excel") {
        console.log("apidata", Translation(apiData, tab));
        // const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        var wscols = [
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 20 },
          { wch: 5 },
          { wch: 20 },
        ];
        ws["!cols"] = wscols;
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Date Used",
            "Activation Code",
            "Security Code",
            "Product Name",
            "PV",
            "Product Cost",
          ],
        ]);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
        // };
      } else if (type === "csv") {
        fileExtension = ".csv";
        let fileType = "text/csv;charset=utf-8";
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Date Used",
            "Activation Code",
            "Security Code",
            "Product Name",
            "PV",
            "Product Cost",
          ],
        ]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      } else if (type === "print") {
        //  let printView = <UserEarningsPrintView
        //      data={apiData}
        // />
      }
    } else {
      if (type === "excel") {
        console.log("apidata", Translation(apiData, tab));
        // const exportToCSV = (apiData, fileName) => {
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        var wscols = [{ wch: 30 }, { wch: 10 }, { wch: 6 }, { wch: 10 }];

        ws["!cols"] = wscols;
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Level",
            "Username",
            "Name",
            // "Activation Code",
            // "Security Code",
            "TOTAL PV",
          ],
        ]);

        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
        // };
      } else if (type === "csv") {
        fileExtension = ".csv";
        let fileType = "text/csv;charset=utf-8";
        const ws = XLSX.utils.json_to_sheet(Translation(apiData, tab));
        XLSX.utils.sheet_add_aoa(ws, [
          [
            "Level",
            "Username",
            "Name",
            // "Activation Code",
            // "Security Code",
            "TOTAL PV",
          ],
        ]);
        const csvOutput = XLSX.utils.sheet_to_csv(ws);
        const data = new Blob([csvOutput], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      } else if (type === "print") {
        //  let printView = <UserEarningsPrintView
        //      data={apiData}
        // />
      }
    }
  };

  // Export Data
  const exportData = (
    startdate = "",
    enddate = "",
    categories = "",
    type,
    tab
  ) => {
    let keys = categories
      .map((key, idx) => {
        return "categories[" + idx + "]=" + key.value;
      })
      .join("&");
    if (tab === "activationCodeHistory") {
      if (type === "excel") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: true,
            csv: false,
            print: false,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
      if (type === "print") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
            print: true,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
      if (type === "csv") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: true,
          },
          HistoryTable: {
            search: false,
            reset: false,
          },
        });
      }
    } else {
      if (type === "excel") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: true,
            csv: false,
          },
        });
      }
      if (type === "print") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: false,
          },
        });
      }
      if (type === "csv") {
        setLoader({
          EarningsTable: {
            search: false,
            reset: false,
            excel: false,
            csv: true,
          },
        });
      }
    }

    if (tab === "activationCodeHistory") {
      service
        .ActivationcodeExportData(startdate, enddate, keys, type)
        .then((res) => {
          if (type === "excel") {
            ExportToExcel(
              res.data.table_data,
              "Activation Code History Report",
              type,
              tab
            );
          }
          if (type === "csv") {
            ExportToExcel(
              res.data.table_data,
              "Activation Code History",
              type,
              tab
            );
          }

          if (type === "print") {
            ExportToExcel(res.data.table_data, "Activation Code History", type);
          }
        });
    } else {
      service.exportData(startdate, enddate, keys, type).then((res) => {
        if (type === "excel") {
          ExportToExcel(res.data.result, "Downline Activation Report", type);
        }
        if (type === "csv") {
          ExportToExcel(res.data.result, "Downline Activation Report", type);
        }

        if (type === "print") {
          ExportToExcel(res.data.result, "Downline Activation Report", type);
        }
      });
    }
  };

  //tab change function(ddn't added this)
  const tabChangeHandler = (tab) => {
    console.log("tabbbbbb", tab);
    setState((prevState) => ({
      ...prevState,
      DataTables: {
        ...prevState.DataTables,
        statement: {
          ...prevState.DataTables.statement,
          perPage: 10,
          inPage: 1,
        },
        history: {
          ...prevState.DataTables.history,
          perPage: 10,
          inPage: 1,
        },
        wallet: {
          ...prevState.DataTables.wallet,
          perPage: 10,
          inPage: 1,
        },
        earnings: {
          ...prevState.DataTables.earnings,
          perPage: 10,
          inPage: 1,
        },
      },
    }));
    setselectedTab(tab);

    // getstatementTable();
    getHistoryTable();
    // getWalletTable();
    getUserEarningsTable();
  };

  const ButtonGroup = [
    {
      name: "ReorderActivation",
      click: fundTransferModal,
    },
  ];

  const paginationHandler = {
    history: changeHistoryTable,
    earnings: changeEarningsTable,
  };

  console.log(state.tilesData, "state.tilesData");
  return (
    <div className={`h-100`} onClick={closeModal}>
      <Helmet>
        <title>
          {companyName.companyName} | {t("Sidemenu.codeActivation")}
        </title>
        <script
          src={`https://www.paypal.com/sdk/js?client-id=${clientSecret}&currency=USD`}
        ></script>
      </Helmet>
      <PageTitle title="codeActivation" buttonOn={true} group={ButtonGroup} />
      {state.loading ? (
        <Spinner />
      ) : (
        <div className={style.MainContainer}>
          <div
            className="reorder_button"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            {state.tilesData && (
              <Tiles
                tilesData={state.tilesData}
                repurchase_status={state.purchase_wallet}
              />
            )}
            <div style={{}}>
              <div style={{ margin: "0 auto", maxWidth: "600px" }}>
                <div style={{ marginTop: "-60px", marginRight: "30px" }}>
                  <Button
                    style={{ height: "40px", borderRadius: "0px" }}
                    className="reorderButton"
                    onClick={handleClick}
                  >
                    <small>
                      <strong>REORDER ACTIVATION</strong>
                    </small>
                  </Button>
                  {showModal && (
                    <CodeActModal
                      onClose={() => setShowModal(false)}
                      monthsList={monthsList}
                      setReload={setReload}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <Content
            tableData={state.DataTables}
            changeHandler={tabChangeHandler}
            paginationHandler={paginationHandler}
            repurchase_status={state.purchase_wallet}
            exportData={exportData}
            loader={loader}
            selectedTab={selectedTab}
            state={state}
          />

          <Modal
            show={state.Modal.fundTransfer}
            onHide={handleClose}
            dialogClassName={`${
              style.ModalDialog
            } animate__animated animate__fadeInRight ${
              state.Modal.fundTransfer
                ? "animate__fadeInRight"
                : "animate__fadeOutRight"
            } FundTransferModal`}
          >
            <Modal.Header closeButton bsPrefix={style.ModalHeader}>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className={style.ModalBodyHeader}>
                <h3>{t("ewallet.ReorderActivation")}</h3>
              </div>
              <ModalForms
                balance={state.balanceAmount}
                transFee={state.TransactionFee}
                submitSuccess={loadData}
                handleClose={handleClose}
                monthsList={monthsList}
              />
            </Modal.Body>
          </Modal>
          {/* Add purchse wallet modal */}
          <Modal
            show={state.Modal.addWallet}
            onHide={handleClose}
            dialogClassName={`${
              style.ModalDialog
            } FundTransferModal animate__animated ${
              state.Modal.addWallet
                ? "animate__fadeInRight"
                : "animate__fadeOutRight"
            }  `}
          >
            <Modal.Header closeButton bsPrefix={style.ModalHeader}>
              <Modal.Title></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className={style.ModalBodyHeader}>
                <h3>{t("ewallet.AddPurchaseWalletFund")}</h3>
              </div>
              <FormInputControl
                label={t("Common.amount")}
                required={true}
                error={{
                  error: EwalletAmount.FormError.amount,
                }}
                // amountAdded = {value => setEwalletAmount(value)}
                checkout={checkout}
                inputProps={{
                  name: "amount",
                  type: "number",
                  placeHolder: t("Common.amount"),
                  onChange: (e) => {
                    changeHandler(e);
                  },
                }}
              />
              {!checkout && (
                <div className="p-2">
                  <pre className={`alert alert-info`}>
                    {t("Common.pwpaypal")}
                  </pre>
                  <div className={style.Buttons}>
                    <Button onClick={checkAvailable} variant="primary">
                      {t("Button.pwpypl")}
                    </Button>
                  </div>
                </div>
              )}
              {checkout && (
                <div className="payment-div">
                  <PaypalPayment
                    amount={EwalletAmount.amount}
                    checkout={(value) => setCheckout(value)}
                    //  getPaypalData={props.getPaypalData}
                  />
                </div>
              )}{" "}
            </Modal.Body>
          </Modal>
        </div>
      )}
    </div>
  );
};

export default withTranslation()(
  connect(mapStateToProps)(withRouter(CodeActivation))
);
